import styled from 'styled-components';
import { Viewer } from '@react-pdf-viewer/core';

export const Container = styled.div`
    display: flex;
`;

export const ViewerContainer = styled(Viewer)``;
